import { MINOR_CONSENT_AGREEMENT_TEXT } from './minor-consent-agreement';
import { MINOR_CONSENT_AGREEMENT_BEKIARES_TEXT } from './minor-consent-agreement-bekiares';

export type MinorConsentVariant = 'standard' | 'bekiares';

export function getMinorConsentAgreementText(variant?: string | null): string {
    return variant === 'bekiares' ? MINOR_CONSENT_AGREEMENT_BEKIARES_TEXT : MINOR_CONSENT_AGREEMENT_TEXT;
}
